import {getRegionPathConfig} from "@/core/utils/helpers/regions/regionUrlHelper";

async function parseServicesParams(searchParams) {
    let fullServices = searchParams.services || [];

    if (typeof fullServices === 'number') {
        fullServices = [fullServices];
    }

    let servicesFromPath = this.extractServicesFromURLPath();

    if (_.isEqual(servicesFromPath[0], constants.seo_filter_ids.MASSAGE)
        && _.includes(fullServices, constants.seo_filter_ids.MASSAGE_NURU)
        && _.includes(fullServices, constants.seo_filter_ids.MASSAGE_TANTRA)
    ) {
        servicesFromPath = null;
    }

    fullServices = _.compact(fullServices.concat(servicesFromPath));

    this.store.commit('setServices', _.uniq(fullServices));
}

async function generateServicesParams(path) {
    let services = this.services;

    const servicesFromURLPath = this.extractServicesFromURLPath(path);

    if (servicesFromURLPath) {
        services = services.filter((service) => servicesFromURLPath.indexOf(service) === -1);
    }

    return services;
}

function extractServicesFromURLPath(path = window.location.pathname || '') {
    const regionPath = getRegionPathConfig();

    let defaultSearchUrl = _.get(this, 'settings.defaultSearchUrl', '');

    if (regionPath) {
        path = path.replace(`/${regionPath}/`, '/');
        defaultSearchUrl = defaultSearchUrl.replace(`/${regionPath}/`, '/');
    }

    /**
     * The default all-escorts search page (region-aware: /sex/ for DE, /escort/uk/ for
     * UK) has no service encoded in its path, so there is nothing to extract.
     */
    if (defaultSearchUrl && _.trim(path, '/') === _.trim(defaultSearchUrl, '/')) {
        return [];
    }

    let splited = _.compact(path.split('/'));

    const paths = constants.seo_filter;

    /**
     * Match the most specific filter URL: try the full path, then drop the trailing
     * segment (a city) and retry. UK prefixes the category slug (escort/erotic-massage),
     * so the filter can be the second segment, not only the first — a fixed length/city
     * heuristic would strip the filter itself on the country-level page.
     */
    while (splited.length) {
        const url = splited.join('/');
        const match = paths.find((filter) => _.trim(filter.url, '/') === url);

        if (match) {
            return _.uniq(_.get(match, 'services', []));
        }

        splited.pop();
    }

    return [];
}

const data = () => ({
    store: $store,
});

export default {
    data,
    methods: {
        parseServicesParams,
        extractServicesFromURLPath,
        generateServicesParams,
    },
    computed: {
        ...mapState([
            'services',
            'settings',
        ]),
    },
}
